import { createElement, useEffect, useContext, useState } from 'react'

import { routeBase } from 'constants/environments.constants'
import useAuthContext from 'contextApi/AuthContext'
import encryptPaymentAdjuster from 'utils/encryptPaymentAdjuster'

const PaymentLink = () => {
  const { userLoggedin } = useContext(useAuthContext)
  const buildUserData = JSON.stringify({
    name: userLoggedin.name,
    email: userLoggedin.email,
    role: userLoggedin.role,
    id: userLoggedin.id,
    origin: 'seller-center',
  })
  const PL_WEB_COMPONENT = routeBase[process.env.REACT_APP_ENVIRONMENT].PAYMENT_LINK_BLOB
  const PL_AUTHORIZATION_KEY =
    routeBase[process.env.REACT_APP_ENVIRONMENT].PAYMENT_LINK_AUTHORIZATION_KEY
  const ENCRYPTION_KEY =
    routeBase[process.env.REACT_APP_ENVIRONMENT].PAYMENT_ADJUSTER_ENCRYPTION_KEY
  const [encryptedKey, setEncryptedKey] = useState(null)
  const [userData, setUserData] = useState(null)
  const createScript = () => {
    const id = 'payment-link-script'
    if (document.getElementById(id)) return
    const script = document.createElement('script')
    script.id = id
    script.src = PL_WEB_COMPONENT
    document.body.appendChild(script)
  }
  useEffect(() => {
    encryptPaymentAdjuster(PL_AUTHORIZATION_KEY, ENCRYPTION_KEY).then((encryptedData) => {
      setEncryptedKey(encryptedData)
    })
    encryptPaymentAdjuster(buildUserData, ENCRYPTION_KEY).then((encryptedData) => {
      setUserData(encryptedData)
    })
    createScript()
  }, [])
  return createElement('lgp-ang-paymentadjuster', {
    authorizationKey: encryptedKey,
    id: 'payment-adjuster-micro-frontend',
    user: userData,
  })
}
export default PaymentLink
